import { render, staticRenderFns } from "./ParamList.vue?vue&type=template&id=80e91bae&scoped=true"
import script from "./ParamList.vue?vue&type=script&lang=js"
export * from "./ParamList.vue?vue&type=script&lang=js"
import style0 from "./ParamList.vue?vue&type=style&index=0&id=80e91bae&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e91bae",
  null
  
)

export default component.exports